import { Namespace } from '_core/utils/ssr';

export const homeConfig = {
  i18nNamespaces: ['common', 'home', 'quotes', 'briefing'] as Namespace,
};
